import {
  SET_NODE_LIST,
  SET_NODE_LIST_PAGE,
  SET_NODE_LIST_PAGE_TOTAL,
  SET_NODE_LIST_STATISTICS,
  SET_NODE_LIST_QUERY,
  SET_NODE_LIST_SORT,
  SET_NODE_LIST_PAGE_SIZE,
  SET_NODE_LIST_SEARCHING,
  SET_ALL_NODE_ITEMS_LIST,
  IF_SELECT_ALLSIZE,
  SET_DATA_LOADED_SIGN,
  IS_QUERY,
  SET_ALL_SIZE,
  SET_GPU_PROPERTY_LIST,
  SET_EXPORTING,
  SET_HARDWARE_RECOMMEND_LIST,
  SET_HARDWARE_RECOMMEND_TOTAL,
} from './mutation-types'
import api from '@/api'
import files from 'file-saver'
import {objectTrim, getHeaderName} from '@/utils'

const initQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  status: '',
  systemproperties: '',
  matchcategory: '',
  associated: '',
  name: '',
  properties: '',
  requirements: '',
  category: '',
  ip: '',
  macCode: '',
  snCode: '',
  core: '',
  startmemory: '',
  endmemory: '',
  mirrorLimit: '',
  cpuName: [],
  realCoreGpuCount: '',
  vrCore: '',
  ipSearchType: 1,
  cdcTag: '',
  modelId: '',
  taskcategory: '',
})
const state = {
  searching: false,
  exporting: false,
  initQuery: initQuery(),
  nodeMessage: {
    list: [],
    listPageTotal: 0,
    statistics: [],
    query: initQuery(),
    setAllSize: 0,
    sort: {},
    allNodeItemsList: [],
  },
  handleAllSize: false,
  dataLoaded: false,
  isQuery: false,
  gpuPropertyList: [],
  hardwareRecommend: {
    list: [],
    total: 0,
  },
}

const mutations = {
  [SET_HARDWARE_RECOMMEND_LIST]  (state, payload) {
    state.hardwareRecommend.list = payload
  },
  [SET_HARDWARE_RECOMMEND_TOTAL] (state, payload) {
    state.hardwareRecommend.total = payload
  },
  [SET_NODE_LIST] (state, payload) {
    state.nodeMessage.list = payload
  },
  [SET_EXPORTING] (state, payload) {
    state.exporting = payload
  },
  [SET_NODE_LIST_QUERY] (state, payload) {
    // 使用 Object.assign 而不是直接赋值，避免触发整个对象的更新产生不必要的性能开销
    Object.assign(state.nodeMessage.query, payload)
  },
  [SET_NODE_LIST_SORT] (state, payload) {
    state.nodeMessage.sort = {
      field: Object.keys(payload)[0],
      fieldValue: Object.values(payload)[0],
    }
  },
  [SET_NODE_LIST_PAGE] (state, payload) {
    state.nodeMessage.query.pageNum = payload
  },
  [SET_NODE_LIST_PAGE_SIZE] (state, payload) {
    state.nodeMessage.query.pageSize = payload
  },
  [SET_NODE_LIST_PAGE_TOTAL] (state, payload) {
    state.nodeMessage.listPageTotal = payload
  },
  [SET_NODE_LIST_STATISTICS] (state, payload) {
    state.nodeMessage.statistics = payload
  },
  [SET_ALL_NODE_ITEMS_LIST] (state, payload) {
    state.nodeMessage.allNodeItemsList = payload
  },
  [SET_NODE_LIST_SEARCHING] (state, payload) {
    state.searching = payload
  },
  [IF_SELECT_ALLSIZE] (state, payload) {
    state.handleAllSize = payload
  },
  [SET_DATA_LOADED_SIGN] (state, payload) {
    state.dataLoaded = payload
  },
  [IS_QUERY] (state, payload) {
    state.isQuery = payload
  },
  [SET_ALL_SIZE] (state, payload) {
    state.nodeMessage.setAllSize = payload
  },
  [SET_GPU_PROPERTY_LIST] (state, payload) {
    state.gpuPropertyList = payload
  },
}

const actions = {
  async selectAllNodeItemsList ({commit, state, dispatch}) {
    try {
      let tempQuery = { ...state.nodeMessage.query }
      if (tempQuery.realCoreGpuCount) {
        tempQuery.realCore = +tempQuery.realCoreGpuCount.split('/')[0]
        tempQuery.gpuCount = +tempQuery.realCoreGpuCount.split('/')[1]
        tempQuery.realCoreGpuCount = undefined
      }
      let { pageNum, pageSize, ...filteredQuery } = objectTrim(tempQuery, false, true, false)
      let param = {
        ...filteredQuery,
        pageNum: 1,
        pageSize: state.nodeMessage.listPageTotal || 100000,
      }
      if (state.nodeMessage.sort.field) param[state.nodeMessage.sort.field] = state.nodeMessage.sort.fieldValue
      const {data, code} = await api.nodeApi.getNodeList(param)
      if (data) {
        commit(SET_ALL_NODE_ITEMS_LIST, data.items || [])
      }
      return {data, code}
    } catch (error) {
      commit(SET_ALL_NODE_ITEMS_LIST, [])
    }
  },
  // 获取节点机列表
  async setNodeList ({commit, state, dispatch}, NodeStatisticsQuery) {
    try {
      let tempQuery = { ...state.nodeMessage.query }
      if (tempQuery.realCoreGpuCount) {
        tempQuery.realCore = +tempQuery.realCoreGpuCount.split('/')[0]
        tempQuery.gpuCount = +tempQuery.realCoreGpuCount.split('/')[1]
        tempQuery.realCoreGpuCount = undefined
      }
      let param = {
        ...objectTrim(tempQuery, false, true, false),
      }
      if (state.nodeMessage.sort.field) param[state.nodeMessage.sort.field] = state.nodeMessage.sort.fieldValue
      if (Object.keys(param).length > 2) {
        commit(IS_QUERY, true)
      } else {
        commit(IS_QUERY, false)
      }
      commit(SET_NODE_LIST_SEARCHING, true)
      const {data} = await api.nodeApi.getNodeList(param)
      if (data) {
        commit(SET_NODE_LIST_SEARCHING, false)
        commit(SET_NODE_LIST_PAGE, data.pageNum || 1)
        commit(SET_NODE_LIST_PAGE_TOTAL, data.total || 0)
        commit(SET_NODE_LIST, data.items || [])
        commit(SET_DATA_LOADED_SIGN, true)
        if (!state.isQuery) {
          commit(SET_ALL_SIZE, data.total)
        }
        if ((!state.isQuery && state.handleAllSize)) {
          commit(SET_NODE_LIST_PAGE_SIZE, data.total)
        }
        if (state.isQuery && state.handleAllSize) {
          if (state.nodeMessage.setAllSize === 0) commit(SET_NODE_LIST_PAGE_SIZE, data.total)
          else commit(SET_NODE_LIST_PAGE_SIZE, state.nodeMessage.setAllSize)
        }
      }
    } catch (error) {
      commit(SET_NODE_LIST_SEARCHING, false)
      commit(SET_NODE_LIST_PAGE_TOTAL, 0)
      commit(SET_NODE_LIST, [])
    }
    const _NodeStatisticsQuery = NodeStatisticsQuery || objectTrim(state.nodeMessage.query, false, true, false)
    const {pageNum, pageSize, ...filteredQuery} = _NodeStatisticsQuery
    dispatch('getNodeStatistics', filteredQuery)
  },
  // 初始化节点机列表
  initNodeList ({dispatch}) {
    dispatch('changeNodeListPage', {currentPage: 1})
  },
  // 节点机列表翻页
  async changeNodeListPage ({commit, state, dispatch}, payload) {
    commit(SET_NODE_LIST_PAGE, payload.currentPage)
    if (!payload.noXHR) await dispatch('setNodeList')
    if (!payload.noXHR) await dispatch('selectAllNodeItemsList')
    return Promise.resolve(true)
  },
  async fetchRenderNodeListDashboard({state}) {
    let tempQuery = { ...state.nodeMessage.query }
    if (tempQuery.realCoreGpuCount) {
      tempQuery.realCore = +tempQuery.realCoreGpuCount.split('/')[0]
      tempQuery.gpuCount = +tempQuery.realCoreGpuCount.split('/')[1]
      tempQuery.realCoreGpuCount = undefined
    }
    let { pageNum, pageSize, ...filteredQuery } = objectTrim(tempQuery, false, true, false)
    const {data} = await api.nodeApi.getNodeDateDashboard(filteredQuery)
    return data
  },
  // 节点机列表筛选
  changeNodeMessageQuery ({commit, state, dispatch}, payload) {
    commit(SET_NODE_LIST_QUERY, payload)
  },
  // 节点机列表排序
  changeNodeMessageSort ({commit, state, dispatch}, payload) {
    commit(SET_NODE_LIST_SORT, payload)
    dispatch('setNodeList')
  },
  // 重置排序
  resetNodeMessageSort ({dispatch}) {
    dispatch('changeNodeMessageSort', {})
  },
  // 获取节点机状态统计数据
  async getNodeStatistics ({commit}, payload) {
    const { data } = await api.nodeApi.getNodeStatistics(payload || {})
    commit(SET_NODE_LIST_STATISTICS, data)
  },
  // 批量设置节点机备注，暂停，删除，继续节点机
  async handleNode ({state, commit, dispatch}, payload) {
    const {result, message, code} = await api.nodeApi.handleNode(payload)
    dispatch('setNodeList')
    return {result, message, code}
  },
  // 开机
  async handlePowerOn ({ state, dispatch }, payload) {
    const { data, code } = await api.nodeApi.powerOnNode(payload)
    dispatch('setNodeList')
    return { data, code }
  },
  // 关机
  async handlePowerOff ({ state, dispatch }, payload) {
    const { data, code } = await api.nodeApi.powerOffNode(payload)
    dispatch('setNodeList')
    return { data, code }
  },
  // 自动开机
  async handleAutoPowerOn ({ state, dispatch }, payload) {
    const { data, code } = await api.nodeApi.changeNodeOnConfig(payload)
    dispatch('setNodeList')
    return { data, code }
  },
  // 自动关机
  async handleAutoPowerOff ({ state, dispatch }, payload) {
    const { data, code } = await api.nodeApi.changeNodeOffConfig(payload)
    dispatch('setNodeList')
    return { data, code }
  },
  // 配置IMPI
  async handleIpmiConfig ({ state, dispatch }, payload) {
    const { result, message, code } = await api.nodeApi.ipmiConfig(payload)
    dispatch('setNodeList')
    return { result, message, code }
  },
  // 获取共同的属性或要求
  async getNodeCommonValue ({state}, payload) {
    let param = {
      ...payload,
    }
    const {data} = await api.nodeApi.getNodeCommonValue(param)
    return data
  },
  // 批量重置属性或要求
  async batchHandleNode ({state, dispatch}, payload) {
    let param = {
      ...payload,
    }
    const {result, message, code} = await api.nodeApi.batchHandleNode(param)
    if (result) {
      dispatch('setNodeList')
    }
    return {result, message, code}
  },
  // 单个重置属性、要求或群组
  async resetSingleNodeValue ({state, dispatch}, payload) {
    let param = {
      ...payload,
    }
    const {result, message, code} = await api.nodeApi.resetSingleNodeValue(param)
    if (result) {
      dispatch('setNodeList')
    }
    return {result, message, code}
  },
  // 修改内核数
  async resetNodeCore ({dispatch}, payload) {
    let param = {
      ...payload,
    }
    const {result, message, code} = await api.nodeApi.resetNodeCore(param)
    if (result) {
      dispatch('setNodeList')
    }
    return {result, message, code}
  },
  // 批量重启
  async restartNode ({dispatch}, payload) {
    let param = {
      ...payload,
    }
    const {result, message, code} = await api.nodeApi.restartNode(param)
    if (result) {
      dispatch('setNodeList')
    }
    return {result, message, code}
  },
  clearIpmiConfig(ctx, payload) {
    return api.nodeApi.clearIpmiConfig(payload)
  },
  // 增加节点机
  async addNode ({dispatch}, payload) {
    const {result, message, code, data} = await api.nodeApi.addNode({node: payload})
    if (result) {
      dispatch('setNodeList')
    }
    return {result, message, code, data}
  },
  // 获取节点机备注
  async getNodeRemark ({state}, payload) {
    let param = {
      ...payload,
    }
    const {data, result, message, code} = await api.nodeApi.getNodeRemark(param)
    return {data, result, message, code}
  },
  // 修改转测试结束时间
  async updateTestEndTime ({state}, payload) {
    let param = {
      ...payload,
    }
    const {data, result, message, code} = await api.nodeApi.updateTestEndTime(param)
    return {data, result, message, code}
  },
  // 获取相同备注的节点机
  async sameRemarkNode ({state}, payload) {
    const {data, result, message, code} = await api.nodeApi.sameRemarkNode(payload)
    return {data, result, message, code}
  },
  // 解决节点机备注问题
  async solveRemarkQuestion ({dispatch}, payload) {
    const {data, result, message, code} = await api.nodeApi.solveRemarkQuestion(payload)
    dispatch('setNodeList')
    return {data, result, message, code}
  },
  // 获取所有平台
  async getPlatform () {
    const {data} = await api.nodeApi.getPlatform()
    return {data}
  },
  // 获取所有状态
  async getNodeAllStatus () {
    const {data} = await api.nodeApi.getNodeAllStatus()
    return data
  },
  // 获取所有线程数
  async getThreadsNumber () {
    const {data} = await api.nodeApi.getThreadsNumber()
    return data
  },
  // 失败率清零
  async errorRateCleared ({state}, params) {
    const res = await api.nodeApi.errorRateCleared(params)
    return res
  },
  // 获取所有扣费物理核数
  async getNodeAllCores () {
    const { data } = await api.nodeApi.getNodeAllCores()
    return data
  },
  // 导出节点全部数据
  async exportNodeAllData ({state, commit}, payload) {
    try {
      let tempParams = {...state.nodeMessage.query}
      delete tempParams.pageNum
      delete tempParams.pageSize
      const params = {
        ...objectTrim(tempParams),
        ...payload,
      }
      commit(SET_EXPORTING, true)
      const {data, headers} = await api.nodeApi.exportNodeAllData(params)
      const fileName = getHeaderName(headers)
      const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      files.saveAs(blob, fileName)
    } catch (e) {
      console.log(e)
    }
    // commit(SET_EXPORTING, false)
  },
  // 获取物理核数
  async getObtainNumber ({state, commit}, payload) {
    const {data} = await api.nodeApi.getObtainNumber()
    return data
  },
  // 获取所有镜像
  async getMirrorList ({state}, payload) {
    const {data, code, message} = await api.nodeApi.getMirrorList(payload)
    return {data, code, message}
  },
  // 获取属性，要求，群组
  async getNodeValues ({state}, payload) {
    const {data} = await api.nodeApi.getNodeValues(payload)
    return {data}
  },
  // 添加属性，要求，群组
  async addNodeValues ({dispatch}, payload) {
    const data = await api.nodeApi.addNodeValues(payload)
    if (data.result) {
      dispatch('setNodeList')
    }
    return data
  },
  // 删除属性，要求，群组
  async delectNodeValues ({dispatch}, payload) {
    const data = await api.nodeApi.delectNodeValues(payload)
    if (data.result) {
      dispatch('setNodeList')
    }
    return data
  },
  // 添加/删除节点机属性、要求有效期记录
  async handleNodeRetentionValues ({dispatch}, payload) {
    const {action, nodeIdList, handle, items, handleValue} = payload
    const params = {
      nodeIdList,
      handle,
    }
    const data = action === 'add'
      ? await api.nodeApi.saveNodeValueExpire({
        ...params,
        items,
      })
      : await api.nodeApi.deleteNodeValueExpire({
        ...params,
        handleValue,
      })
    if (data.result) {
      dispatch('setNodeList')
    }
    return data
  },
  // 查询指定节点机当前有效期内的属性、要求记录
  async getNodeRetentionValidityList (ctx, payload) {
    return api.nodeApi.listNodePropertyExpire(payload)
  },
  // 编辑单条有效期记录保留天数
  async updateNodeRetentionValidity (ctx, payload) {
    return api.nodeApi.updateNodeValueExpireDays(payload)
  },
  // 单个或多个节点机修改镜像
  async changeMirror ({state, dispatch}, payload) {
    const {result, message, code} = await api.nodeApi.changeMirror(payload)
    if (result) {
      dispatch('setNodeList')
    }
    return {result, message, code}
  },
  // 自动切换镜像
  async editAutoChangeSetting ({state, dispatch}, payload) {
    const {result, message, code} = await api.nodeApi.editAutoChangeSetting(payload)
    if (result) {
      dispatch('setNodeList')
    }
    return {result, message, code}
  },
  // 查询自动切换镜像设置
  async getAutoChangeSetting() {
    const {data} = await api.nodeApi.getAutoChangeSetting()
    return data
  },
  // 获取系统属性
  async getSystemProperty () {
    const {data} = await api.nodeApi.getSystemPrperty()
    return data
  },
  // 标记选择全部页时
  labelIfSelectAllSize ({commit}, payload) {
    commit(IF_SELECT_ALLSIZE, payload)
  },
  clearDataLoadedSign ({commit}) {
    commit(SET_DATA_LOADED_SIGN, false)
  },
  refreshSetAllSize ({commit}, payload) {
    commit(SET_ALL_SIZE, payload)
  },
  async moveToRent ({dispatch}, payload) {
    const {
      leasePlan,
      salesperson,
      ...params
    } = payload
    const {result, code} = await api.nodeApi.moveRenderNodeToLease({
      ...params,
      ...(leasePlan ? {leasePlanName: leasePlan} : {}),
      ...(salesperson !== '' && salesperson !== undefined ? {salesmanId: salesperson} : {}),
    })
    if (result) {
      dispatch('setNodeList')
    }
    return {result, code}
  },
  // 释放机器
  async releaseIdleNode ({dispatch}, payload) {
    const {result, message, code} = await api.nodeApi.releaseIdleNode(payload)
    if (result) {
      dispatch('setNodeList')
    }
    return {result, message, code}
  },
  // 查询机器白名单
  async queryMachineWhiteList ({dispatch}, payload) {
    const {data, message, code} = await api.nodeApi.queryMachineWhiteList(payload)
    return {data, message, code}
  },
  // 添加机器白名单
  async addMachineWhiteList ({dispatch}, payload) {
    const {data, message, code} = await api.nodeApi.addMachineWhiteList(payload)
    return {data, message, code}
  },
  // 获取属性,要求,群组,约束名列表
  async renderNodeParams ({commit, state}, payload) {
    const { data } = await api.nodeApi.renderNodeParams(payload)
    return data
  },
  // 获取GPU属性
  async getGPUProperty ({commit}) {
    const {data} = await api.nodeApi.gpuProperty()
    if (data) {
      commit(SET_GPU_PROPERTY_LIST, data)
    } else {
      commit(SET_GPU_PROPERTY_LIST, [])
    }
  },
  // 指派命令
  async postCommand({commit}, payload) {
    const {code} = await api.nodeApi.postCommand(payload)
    return code
  },
  // 开启镜像限制
  async openMirrorLimit({commit, dispatch}, payload) {
    const {code} = await api.nodeApi.openMirrorLimit(payload)
    if (code === 200) {
      dispatch('setNodeList')
    }
    return code
  },
  // 关闭镜像限制
  async closeMirrorLimit({commit, dispatch}, payload) {
    const {code} = await api.nodeApi.closeMirrorLimit(payload)
    if (code === 200) {
      dispatch('setNodeList')
    }
    return code
  },
  // 用户是否存在
  async existUserByName ({commit, state}, payload) {
    const { data } = await api.nodeApi.existUserByName(payload)
    return data
  },
  // 编辑SN编号
  async editSnCode ({commit, state, dispatch}, payload) {
    let param = {
      ...payload,
    }
    const {result, message, code} = await api.nodeApi.editSnCode(param)
    if (result) {
      dispatch('setNodeList')
    }
    return {result, message, code}
  },
  // 导入节点机数据
  async importAdminNodeData ({commit, state, dispatch}, payload) {
    const {result, message, code, data} = await api.nodeApi.importAdminNodeData(payload)
    if (code === 200) {
      dispatch('setNodeList')
    }
    return {result, message, code, data}
  },
  // 导出节点数据
  async exportExcel({commit, state, dispatch}, payload) {
    try {
      let params = {
        ...objectTrim(state.nodeMessage.query),
        ...payload,
      }
      commit(SET_EXPORTING, true)
      const {data, headers} = await api.nodeApi.exportNodeData(params)
      const fileName = getHeaderName(headers)
      const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      files.saveAs(blob, fileName)
    } catch (e) {
      console.log(e)
    }
    commit(SET_EXPORTING, false)
  },
  // 获取硬件推荐配置
  async getHardwareRecommendation ({commit, dispatch}, payload) {
    try {
      const {data} = await api.nodeApi.getHardwareRecommendation()
      if (data.length) {
        commit(SET_HARDWARE_RECOMMEND_LIST, data)
        commit(SET_HARDWARE_RECOMMEND_TOTAL, 1)
      } else {
        commit(SET_HARDWARE_RECOMMEND_LIST, [])
        commit(SET_HARDWARE_RECOMMEND_TOTAL, 0)
      }
    } catch (error) {
      commit(SET_HARDWARE_RECOMMEND_LIST, [])
      commit(SET_HARDWARE_RECOMMEND_TOTAL, 0)
    }
  },
  // 删除硬件推荐配置
  async deleteConfiguration ({dispatch}, payload) {
    const {result, code} = await api.nodeApi.deleteConfiguration(payload)
    return {result, code}
  },
  // 获取可以释放的机器数量
  async queryReleaseCount(ctx, payload) {
    const { code, data } = await api.nodeApi.queryReleaseCount(payload)
    return code === 200 && data ? data : 0
  },
  // 获取免费渲小样配置信息
  async getFreeRenderSampleConfig() {
    const res = await api.nodeApi.getFreeRenderSampleConfig()
    return res
  },
  // 获取免费渲小样操作记录
  async getFreeRenderSampleConfigRecord(_, payload) {
    const res = await api.nodeApi.getFreeRenderSampleConfigRecord(payload)
    return res
  },
  // 获取自动申请机器比例
  async getApplyNodeRate() {
    const { code, data } = await api.nodeApi.getApplyNodeRate()
    return code === 200 && data.data ? data.data : 0
  },
  // 设置自动申请机器比例
  async setApplyNodeRate(ctx, payload) {
    const res = await api.nodeApi.setApplyNodeRate(payload)
    return res
  },
  // 获取设置加速比例
  async getFastNodeRate() {
    const { code, data } = await api.nodeApi.getFastNodeRate()
    return code === 200 && data ? data : 0
  },
  // 设置加速比例
  async setFastNodeRate(ctx, payload) {
    const res = await api.nodeApi.setFastNodeRate(payload)
    return res
  },
  // 释放机器
  async releaseNode(ctx, payload) {
    const res = await api.nodeApi.releaseNode(payload)
    return res
  },
  // 申请机器
  async applyNode(ctx, payload) {
    const res = await api.nodeApi.applyNode(payload)
    return res
  },
  // 获取申请机器记录
  async queryNodeOperatorRecord(ctx, payload) {
    const res = await api.nodeApi.queryNodeOperatorRecord(payload)
    return res
  },
  async queryNodeReleaseRecord(ctx, payload) {
    const res = await api.nodeApi.queryNodeReleaseRecord(payload)
    return res
  },
  // 查询机器模板
  async queryCloudTemplate(ctx, payload) {
    return api.nodeApi.queryCloudTemplate(payload)
  },
  // 编辑机器模板
  async editCloudTemplate(ctx, payload) {
    return api.nodeApi.editCloudTemplate(payload)
  },
  // 删除机器模板
  async delCloudTemplate(ctx, payload) {
    return api.nodeApi.delCloudTemplate(payload)
  },
  // 获取自动申请机器策略
  async queryMachineApplyTimeConfigList() {
    const res = await api.nodeApi.queryMachineApplyTimeConfigList()
    return res
  },
  // 设置自动申请机器策略
  async setMachineApplyTimeConfig(ctx, payload) {
    const res = await api.nodeApi.setMachineApplyTimeConfig(payload)
    return res
  },
  // 查询机器规格/模板机器分配设置
  async queryMachineDistributeSetting(ctx, payload) {
    const res = await api.nodeApi.queryMachineDistributeSetting(payload)
    return res
  },
  // 修改机器资源池比例
  async updateMachineDistributeSetting(ctx, payload) {
    const res = await api.nodeApi.updateMachineDistributeSetting(payload)
    return res
  },
  // 删除自动申请机器策略
  async deleteMachineApplyTimeConfigTemplate(ctx, payload) {
    const res = await api.nodeApi.deleteMachineApplyTimeConfigTemplate(payload)
    return res
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
